import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { EmployeeAuthProvider } from './contexts/EmployeeAuthContext'
import { AuthProvider } from './contexts/AuthContext'
import { FestiveProvider } from './contexts/FestiveContext'

function App() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <AuthProvider>
        <EmployeeAuthProvider>
          <FestiveProvider>
            {/* <SnowfallWrapper> */}
            <AppRoutes />
            {/* </SnowfallWrapper> */}
          </FestiveProvider>
        </EmployeeAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App